export const API_URL = '/api';

//export const API_URL = 'http://127.0.0.1:8080/api';
